import type { ProductStatus } from '../../recoil/types/onsaTypes';
import InsuranceSumsPRCStep from './steps/privateContent/InsuranceSumsPRCStep';
import InsuranceSumsYoungPRCStep from './steps/youngPrivateContent/InsuranceSumsYoungPRCStep';

type AdditionalInformationConfig = Array<{
    id: string;
    Component: React.ComponentType<{
        goNext: () => void;
        goPrevious: () => void;
    }>;
}>;

export const getAdditionalInformationConfig = (
    currentProduct: ProductStatus
): AdditionalInformationConfig => {
    switch (currentProduct?.flavourName) {
        case 'Indboforsikring':
            return privateContentConfig;
        case 'Indboforsikring til unge':
            return youngPrivateConfig;
        default:
            return [];
    }
};

const privateContentConfig: AdditionalInformationConfig = [
    {
        id: 'InsuranceSums',
        Component: InsuranceSumsPRCStep
    }
];

const youngPrivateConfig: AdditionalInformationConfig = [
    {
        id: 'youngInsuranceSums',
        Component: InsuranceSumsYoungPRCStep
    }
];
